import React from 'react';
import PropTypes from 'prop-types';

class CustomInteractionOral extends React.PureComponent {
    static propTypes = {
        handleInteractionReady: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.handleInteractionReady(true);
    }

    render() {
        return null;
    }
}

export default CustomInteractionOral;
